import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiClock, FiNavigation } = FiIcons;

const Contact = () => {
  const { themeConfig } = useTheme();
  const { contact } = themeConfig;

  return (
    <section id="contact" className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-4">
            {contact.title}
          </h2>
          <p className="text-lg text-warm-brown/70 max-w-2xl mx-auto">
            {contact.subtitle}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="flex items-start gap-4">
              <div className="bg-cream p-3 rounded-full">
                <SafeIcon icon={FiMapPin} className="text-warm-brown text-xl" />
              </div>
              <div>
                <h3 className="text-xl font-playfair text-warm-brown mb-2">Location</h3>
                <p className="text-warm-brown/80">{contact.location}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-cream p-3 rounded-full">
                <SafeIcon icon={FiClock} className="text-warm-brown text-xl" />
              </div>
              <div>
                <h3 className="text-xl font-playfair text-warm-brown mb-2">Hours</h3>
                <div className="space-y-1">
                  {contact.hours.map((schedule, index) => (
                    <div key={index} className="flex justify-between text-warm-brown/80">
                      <span className="font-medium">{schedule.days}:</span>
                      <span>{schedule.time}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="pt-6"
            >
              <a
                href={contact.directionsButtonLink}
                target="_blank"
                rel="noreferrer"
                className="bg-warm-brown text-cream px-6 py-3 rounded-full font-medium hover:bg-warm-brown/90 transition-colors duration-300 shadow-lg inline-flex items-center justify-center gap-3"
              >
                <SafeIcon icon={FiNavigation} className="text-lg" />
                {contact.directionsButtonText}
              </a>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src={contact.image}
              alt="La Vie Saigon café"
              className="rounded-lg shadow-2xl w-full h-80 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-warm-brown/20 to-transparent rounded-lg" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;